import React, { memo, useCallback } from 'react';
import metadata from 'lib/metadata';

import { RecoverPassword } from '@Sage/ssm-web5';
import Logo from 'components/Logo';

import Context from 'managers/Context';

import './styles.scss';

const Web4RecoverPassword = memo(() => {
    const send = useCallback(
        (email) =>
            Context.domainManager.recoverPassword({ email }).then((result) => {
                if (result.includes("status='isazure'"))
                    return 'label_azure_password_cannot_be_changed';
                return 'succes_new_password_email_sent';
            }),
        [],
    );

    return (
        <div className="fm-recover-password">
            <RecoverPassword
                logo={<Logo width={metadata.mainLogoWidth} />}
                onSend={send}
                iframeURL={metadata.iframeURL}
            />
        </div>
    );
});

export default Web4RecoverPassword;
